export const STUDENT_REPORT_LOGIN_FEATURE_ID = 'student_report_login';

export const STUDENT_REPORT_LOGIN_EVENT_NAMES = {
  STUDENT_LOGIN_SUCCESS: 'student_report_login.student_success',
  ASSIGNMENT_ENABLED: 'student_report_login.assignment_enabled',
  ORG_ENABLED: 'student_report_login.org_enabled',
  ORG_DISABLED: 'student_report_login.org_disabled',
  ROOM_CODE_PDF_DOWNLOAD: 'student_report_login.room_code_pdf_download',
  ROOM_CODE_TAB_CLICKED: 'student_report_login.room_code_tab_clicked',
} as const;

export type StudentReportLoginEventName =
  (typeof STUDENT_REPORT_LOGIN_EVENT_NAMES)[keyof typeof STUDENT_REPORT_LOGIN_EVENT_NAMES];

export const STUDENT_REPORT_LOGIN_USAGE_EVENTS = [
  {
    eventId: 'student_login',
    label: 'Room Code Log-ins',
    eventName: STUDENT_REPORT_LOGIN_EVENT_NAMES.STUDENT_LOGIN_SUCCESS,
  },
  {
    eventId: 'room_code_tab_click',
    label: 'Room Code Log-in tab clicks',
    eventName: STUDENT_REPORT_LOGIN_EVENT_NAMES.ROOM_CODE_TAB_CLICKED,
  },
  {
    eventId: 'assignment_enabled',
    label: 'Assignment opt-ins',
    eventName: STUDENT_REPORT_LOGIN_EVENT_NAMES.ASSIGNMENT_ENABLED,
  },
  {
    eventId: 'org_enabled',
    label: 'Orgs enabled now',
    eventName: STUDENT_REPORT_LOGIN_EVENT_NAMES.ORG_ENABLED,
  },
  {
    eventId: 'room_code_pdf_download',
    label: 'Room Code PDFs',
    eventName: STUDENT_REPORT_LOGIN_EVENT_NAMES.ROOM_CODE_PDF_DOWNLOAD,
  },
] as const;

export type StudentReportLoginUsageEventId =
  (typeof STUDENT_REPORT_LOGIN_USAGE_EVENTS)[number]['eventId'];
